import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { consentApi } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { OAuthButtons } from './OAuthButtons';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      // Synchroniser le consentement cookies stocké localement
      const cookieConsent = localStorage.getItem('cookie_consent');
      if (cookieConsent) {
        consentApi.syncCookies(cookieConsent === 'accepted').catch(() => {});
      }
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erreur de connexion. Vérifiez vos identifiants.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Connexion</h1>
        
        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.com"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <OAuthButtons mode="login" />

        <div className="auth-links">
          <a href="/forgot-password">Mot de passe oublié ?</a>
          <span>·</span>
          <a href="/register">Créer un compte</a>
        </div>
      </div>
    </div>
  );
};
